import { render } from "./pharmacyeditsupplier.vue?vue&type=template&id=3ae6f556"
import script from "./pharmacyeditsupplier.vue?vue&type=script&lang=js"
export * from "./pharmacyeditsupplier.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__